export default "__VITE_ASSET__BvPy2VPW__"